import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true,  // Show sidebar by default on desktop
  sidebarUnfoldable: false,
  theme: 'light'
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    set: (state, action) => {
      return { ...state, ...action.payload }
    },
    setSidebarShow: (state, action) => {
      state.sidebarShow = action.payload
    },
    toggleSidebarShow: (state) => {
      state.sidebarShow = !state.sidebarShow
    },
    setSidebarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload
    },
    toggleSidebarUnfoldable: (state) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    }
  }
})

export const { 
  set, 
  setSidebarShow, 
  toggleSidebarShow,
  setSidebarUnfoldable, 
  toggleSidebarUnfoldable,
  setTheme 
} = uiSlice.actions

export default uiSlice.reducer
